import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CutoffService } from 'src/app/services/cutoff.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { StoreService } from 'src/app/services/store.service';
import Swal from 'sweetalert2';
import { StoresAttrValidationComponent } from '../stores-attr-validation/stores-attr-validation.component';


@Component({
  selector: 'app-new-attribute-rule',
  templateUrl: './new-attribute-rule.component.html',
  styleUrls: ['./new-attribute-rule.component.scss']
})
export class NewAttributeRuleComponent implements OnInit {
  dataR!: any;
  initialDataRegla: any;

  comparadores = ['Igual a', 'Mayor o igual que', 'Menor o igual que'];
  operadores = [{id: 1, nombre: "Multiplicación"}, {id: 2, nombre: "División"}];
  atributos : any[] = [];
  nombreAtributo = "";
  type_att = 0;
  att_options = [];

  isEdit : boolean = false;

  hasPosicion : boolean = false;
  //1 //operador: 0 ninguno, 1 mult, 2 div
  sumatoriaObj : any = { attributes : [], operador : 0, valor_operacion : 0 };
  //2 //operador 1 Mayo que, operador 2 menor que, Operador 3 igual a
  mayormenorObj : any = { attribute : 0, operador : 1, valor_comparar : '', valor_atributo : '' }
  //3
  rangoObj : any = { attribute : 0, valor_min : 0, valor_max : 0,  valor_atributo : 0 }
  type_sel: number = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any, 
    public dref: MatDialogRef<NewAttributeRuleComponent>,
    private matDialog: MatDialog,
    private _main :MainService, 
    private _cutoff : CutoffService, 
    private _projectService : ProjectsService, 
    private _storesServices : StoreService
  ) { }

  ngOnInit(): void {
    this.isEdit = this.data.isEdit;
    this.nombreAtributo = this.data.atributo.name;
    this.type_att = this.data.atributo.type_id;
    if(this.type_att == 3) {
      this.att_options = JSON.parse(this.data.atributo.select_data);
    }
    console.log(this.data);
    console.log(this.type_att);
    if(!this.isEdit){
      this.dataR = {
        nombre : '',
        tipo : 1,
        data_regla : JSON.parse(JSON.stringify(this.sumatoriaObj)),
        id_atributo : this.data.atributo.id
      };
    }else{
      this.dataR = JSON.parse(JSON.stringify(this.data.atributo_regla));
      this.dataR.data_regla = JSON.parse(this.dataR.data_regla);
      this.initialDataRegla = JSON.parse(JSON.stringify(this.dataR.data_regla));
    }

    this.getAtributos();

  }

  close(): void { this.dref.close(); }


  invalidInput(): boolean {
    return this.dataR.nombre === '' || 
    this.invalidDivisionValue() || 
    ((this.dataR.tipo === 1 || this.dataR.tipo === 4) && (
      this.dataR.data_regla.attributes.length === 0 ||
      this.dataR.data_regla.operador === 0 ||
      this.dataR.data_regla.valor_operacion === 0
    )) ||
    (this.dataR.tipo === 2 && (
      this.dataR.data_regla.attribute === 0 || 
      this.dataR.data_regla.operador === 0 || 
      this.dataR.data_regla.valor_comparar === '' || 
      this.dataR.data_regla.valor_atributo === ''
    )) || 
    (this.dataR.tipo === 3 && (
      this.dataR.data_regla.attribute === 0
    ));
  }

  invalidDivisionValue(): boolean {
    if (this.dataR.tipo !== 1 || this.dataR.data_regla.operador !== 2) {
      return false;
    }

    const valorOperacion = Number(this.dataR.data_regla.valor_operacion);
    return !Number.isFinite(valorOperacion) || valorOperacion == 0;
  }

  onTipoCambio(event: any) {
    console.log('Nuevo valor seleccionado:', event.value);
    
    this.onTipoCambioByValue(event.value);

  }

   onTipoCambioByValue(value: any) {
    console.log('Nuevo valor seleccionado:', value);
    const currentData = this.dataR.data_regla;
    const initialData = this.initialDataRegla || {};

    if(value == 1){
      this.dataR.data_regla = Object.assign({}, JSON.parse(JSON.stringify(this.sumatoriaObj)), {
        attributes: currentData.attributes || initialData.attributes || []
      });
    }
    if(value == 2){
      this.dataR.data_regla = Object.assign({}, JSON.parse(JSON.stringify(this.mayormenorObj)), { 
        attribute: currentData.attribute || initialData.attribute || 0,
        operador: currentData.operador || initialData.operador || 1,
        valor_comparar: currentData.valor_comparar || initialData.valor_comparar || '',
        valor_atributo: currentData.valor_atributo || initialData.valor_atributo || ''
      });
    }
    if(value == 3){
      this.dataR.data_regla = Object.assign({}, JSON.parse(JSON.stringify(this.rangoObj)), {
        attribute: currentData.attribute || initialData.attribute || 0,
        valor_min: currentData.valor_min || initialData.valor_min || 0,
        valor_max: currentData.valor_max || initialData.valor_max || 0,
        valor_atributo: currentData.valor_atributo || initialData.valor_atributo || 0
      });
    }
    if(value == 4){
      this.dataR.data_regla = Object.assign({}, JSON.parse(JSON.stringify(this.sumatoriaObj)), {
        attributes: currentData.attributes || initialData.attributes || []
      });
    }

  }

  mirror(event: KeyboardEvent): void {
    const input: HTMLInputElement = event.target as HTMLInputElement;
    
    if (event.key === 'ArrowUp') {
      event.preventDefault(); 
      input.value = Math.max(1, (parseInt(input.value, 10) || 0) - 1).toString(); // Arrow up subtracts
    } else if (event.key === 'ArrowDown') {
      event.preventDefault(); // Prevent default scrolling behavior.
      input.value = ((parseInt(input.value, 10) || 0) + 1).toString(); // Arrow down adds
    }

    this.dataR.prioridad = parseInt(input.value, 10);
  }

  getRanges(rangeSelect : any){
    return rangeSelect.split("-");
  }

  converToObject(obj: string){
    try{
      return JSON.parse(obj);
    }catch(ex){
      return [];
    }
  }

  setItemName(value : any, rule : any){
    const selectedAtributo = this.atributos.find(x => x.id === value);
    if (selectedAtributo) {
        this.type_sel = selectedAtributo.type_id;
        rule.nombre = selectedAtributo.name;
        if(rule.operador){
          rule.operador = 1;
        } 
    }
  }

  getItem(atribute_id : any) : any{
    return this.atributos.filter(x=>  x.id === atribute_id)[0];
  }


  getAtributos(){
    this._main.ShowLoading();
    this._cutoff.getAtributos().subscribe((x: any) => {
      this._main.HideLoading();

      this.atributos = x.data.filter((x:any)=> x.id != this.data.atributo.id);
      this.type_sel = x.data.find((x:any)=> x.id == this.data.atributo_regla.id).type_id || 0;
     //console.log("data info", this.data);
     //console.log("current data", this.dataR, this.type_sel, this.atributos);
    });
    
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  register(): void {  
    this.dataR.data_regla = JSON.stringify(this.dataR.data_regla);

      Swal.fire({
       icon: 'info',
       title: 'Guardando...',
       allowEscapeKey: false,
       allowOutsideClick: false,
       showConfirmButton: false,
       didOpen: () => {
         Swal.showLoading();
       }
     });

     this._storesServices.createRuleAtributo(this.dataR).subscribe(
       (result:any) => {
         if(result.message == "Success") {

          if(result?.data?.length > 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Guardado',
              html: 'No se pudieron realizar los cálculos porque hay valores fuera de rango'
            }).then(() => {            
              this.openDialogVlidate(result.data);
            }); 
          }
           else {
            Swal.fire({
             icon: 'success',
             title: 'Guardado',
             html: 'Registro guardado correctamente'
           }).then(() => {            
             this.dref.close(this.dataR);
           });
          }
         }
         else {
           Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
         });
         }
       },
       (err:any) => {
         console.log(err);
         Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
         });
       }
     );
    

    this.dref.close(this.dataR); 
}

openDialogVlidate(data : any) {
  this.matDialog.open(StoresAttrValidationComponent, {
    panelClass: 'dialogs-lg',
    data
  }).afterClosed().subscribe(
    resp => {
      this.dref.close(this.dataR);
    }
  );
}


edit(): void {  
this.dataR.data_regla = JSON.stringify(this.dataR.data_regla);
Swal.fire({
 icon: 'info',
 title: 'Guardando...',
 allowEscapeKey: false,
 allowOutsideClick: false,
 showConfirmButton: false,
 didOpen: () => {
   Swal.showLoading();
 }
});

this._storesServices.editRuleAtributo(this.dataR).subscribe(
 (result:any) => {
   if(result.message == "Success") {
    if(result?.data?.length > 0 ) {
      Swal.fire({
        icon: 'warning',
        title: 'Guardado',
        html: 'No se pudieron realizar los cálculos porque hay valores fuera de rango'
      }).then(() => {            
        this.openDialogVlidate(result.data);this.dref.close(this.dataR);
      }); 
    }
     else {
     Swal.fire({
       icon: 'success',
       title: 'Guardado',
       html: 'Guardado exitosamente'
     }).then(() => {            
       this.dref.close(this.dataR);
     });
    }
   }
 },
 (err:any) => {
   console.log(err);
   Swal.fire({
     icon: 'error',
     title: 'Error al guardar',
     text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
   });
 }
);


this.dref.close(this.dataR); 
}

  
}
